<div class="d-flex flex-column box--one">
  <div *ngFor="let it of list" [ngClass]="boxClass(it)" (click)="select(it)">
    <div [ngClass]="textClass(it)">{{ it.name }}</div>
  </div>
</div>
